import ApplicationController from './application_controller'
export default class extends ApplicationController {
  static targets = ["content"]
  static values = {
    url: String,
    interval: { type: Number, default: 2000 },
    retryInterval: { type: Number, default: 3000 }
  }

  connect() {
    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    this.poll()
  }

  stopPolling() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  poll() {
    fetch(this.urlValue, {
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.status === 'ready' || data.status === 'error') {
          this.contentTarget.innerHTML = data.html
        } else {
          // Continuer le polling
          this.timeout = setTimeout(() => this.poll(), this.intervalValue)
        }
      })
      .catch(error => {
        console.error('Polling error:', error)
        // Réessayer en cas d'erreur
        this.timeout = setTimeout(() => this.poll(), this.retryIntervalValue)
      })
  }
}
